(function () {

    'use strict';

    angular.module('Services').service('AccountingInvoicesTableService', AccountingInvoicesTableService);

    AccountingInvoicesTableService.$inject = [
        'AccountingService',
        'TableLiteFactory',
        '$location',
        '$rootScope',
        '$filter'
    ];

    function AccountingInvoicesTableService(
        AccountingService,
        TableLiteFactory,
        $location,
        $rootScope,
        $filter
    ) {
        return function () {
            const tableData = {
                tableName: 'AccountingInvoicesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Invoice',
                        tooltip: 'Add New Invoice',
                        onClick: function () {
                            $location.path('/accounting/invoices/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Date of Carrier Invoice',
                        viewName: 'dateOfInvoice',
                        filter: {
                            type: 'datePicker',
                            class: 'filter-date',
                            toModel: '',
                            fromModel: '',
                            format: 'dd/MM/yyyy',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    // {
                    //     label: 'CARRIER',
                    //     viewName: 'carrierName',
                    //     sortName: 'carrier.carrierName',
                    //     filter: {
                    //         type: 'text',
                    //         placeholder: 'Search',
                    //         onSubmit: function (header) {
                    //             sendRequest(evaluateFilter(header));
                    //         }
                    //     },
                    //     headerFn: function(header) {
                    //         sort(this.sortName);
                    //     }
                    // },
                    {
                        label: 'Invoice Number',
                        viewName: 'invoiceNumber',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Carrier Name',
                        viewName: 'carrierName',
                        filterName: 'carrier.carrierName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: ''
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Invoice Amount',
                        viewName: 'amountStr',
                        filterName: 'invoiceAmount',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Margin Value',
                        viewName: 'marginFixed',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Margin %',
                        viewName: 'marginPercent',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-capitalize',
                        label: 'Status',
                        viewName: 'status',
                        filterName: 'status',
                        width: '100px',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Unreconciled', 'Discrepancy', 'Disputed', 'Pending'],
                            onSelect: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.Invoices.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    status: ['unreconciled', 'pending', 'discrepancy', 'disputed']
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data) return null;
                
                angular.forEach(data.content, function (invoice) {
                    invoice.dateOfInvoice = $filter('bbaDate')(invoice.dateOfInvoice);
                    invoice.carrierName = angular.getObjVal(invoice, 'carrier.carrierName') || 'N/A';
                    invoice.amountStr = $filter('bbaCurrency')(invoice.invoiceAmount);
                    invoice.marginFixed = $filter('bbaCurrency')(invoice.marginFixed);

                    invoice.marginPercent = (invoice.marginPercent || 0) * 100 + '%';
                    invoice.href = '/accounting/invoices/' + invoice.id;
                    tableData.data.push(invoice);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingInvoicesTableService.js